import {
    getInsuranceCompanies,
    getMrgerInsuranceCompanies,
    createOtherPropertyInsurance,
    queryOtherPropertyInsurance,
    updateOtherPropertyInsurance,
    deleteOtherPeropertyInsurance,
    insertDataCollectionLog
} from "@/service";
import CommonMixins, { padLeft } from "./common";
import moment from "moment";
import TruncateTool from "./components/TruncateTool";
import PropertyCompanyMergeModal from "./components/PropertyCompanyMergeModal";
import { commonMixin as GolbalCommonMixins } from '@/mixins/common'


export default {
    mixins: [CommonMixins, GolbalCommonMixins],
    components: { TruncateTool, PropertyCompanyMergeModal },
    data: () => ({
        options: {
            companies: [],
            mrgerCompaniesList: []
        },
        editData: {
            insured: "",
            agidno: "",
            compid: "",
            plcno: "",
            prd: "",
            prem: "",
            famt: ""
        },
        mergeModalOpen: false
    }),
    methods: {
        getName(csidno) {
            return window._.get(
                this.options.families.find((i) => i.csidno === csidno),
                "name"
            );
        },
        async getOptions() {
            this.getFamilyOption();
            this.getInsuranceCompaniesOption();
            this.getMrgerInsuranceCompaniesOption();
        },
        async getInsuranceCompaniesOption() {
            const res = await getInsuranceCompanies(this.user_id);
            this.options.companies = res.body;
        },
        async getMrgerInsuranceCompaniesOption() {
            const res = await getMrgerInsuranceCompanies(this.user_id);
            this.options.mrgerCompaniesList = res.body;
        },
        async getData() {
            const res = await queryOtherPropertyInsurance({
                pt_contractx_id: this.pt_contractx_id
            });
            const rdstdt = moment(res.body.rdstdt);
            const FIRE_INSURANCE_TYPE = 2;
            this.editData = {
                ...res.body,
                year: rdstdt.getROCDate("YYYY"),
                month: padLeft(2, "0")(rdstdt.month() + 1),
                day: padLeft(2, "0")(rdstdt.date()),
                insured: res.body.insurancetype == FIRE_INSURANCE_TYPE ?
                    res.body.applicant : res.body.insured,
                target_birth: res.body.target_birth ? res.body.target_birth : "",
            };
        },
        async checkValidate() {
            return new Promise(async(resolve) => {
                if ((await this.$validator.validateAll())) {
                    resolve();
                } else {
                    if (this.errors.firstByRule("prd", "min_value")) {
                        this.$toast.info({ title: "年期需大於0" });
                    } else if (this.errors.firstByRule("prd", "max")) {
                        this.$toast.info({ title: "年期不得超過三碼數字" });
                    }
                    const errorRuls = this.errors.items.map((x) => x.rule);
                    if (errorRuls.filter((x) => x === "numeric").length) {
                        this.$toast.info({ title: "欄位格式有錯" });
                    }
                    if (errorRuls.filter((x) => x === "required").length) {
                        this.$toast.info({ title: "尚有欄位未填寫" });
                    }
                    if (errorRuls.filter((x) => x === "checkEngNumDash").length) {
                        this.$toast.info({ title: "契約別只能輸入英文與數字" });
                    }
                    if (errorRuls.filter((x) => x === "checkCarType").length) {
                        this.$toast.info({ title: "契約別只能輸入英文與數字" });
                    }
                    if (errorRuls.filter((x) => x === "checkRemark").length) {
                        this.$toast.info({ title: "備註不可輸入特殊字符" });
                    }
                    if (errorRuls.filter((x) => x === "checkCarTypeLength").length) {
                        this.$toast.info({ title: "車種欄位只能輸入40字元" });
                    }
                    let feild = {
                        carno: "車牌號碼",
                        engine_no: "引擎號碼",
                        plcno: "保單號碼"
                    };
                    // window._.forEach(this.errors.items, (item) => {
                    //     if (item.rule === "checkEngNumDash") {
                    //         this.$toast.info({
                    //             title: feild[item.field] + "只能輸入英文與數字和-符號"
                    //         });
                    //     }
                    // });
                }
            });
        },
        async doUpdate() {
            if(this.confirm_checkbox){
                await this.checkValidate();
                if(window.trn_cd){
                    await insertDataCollectionLog(this.$store.state.userInfo.id, window.csidno, window.trn_cd).then(result => {
                        if(!result.header || !result.header.status === '200') {
                            if(result.header.message) {
                              this.$toast.info({title: result.header.message})
                            } else {
                              this.$toast.info({title: `${resMessage}`})
                            }     
                        }
                    })
                    delete window.trn_cd;
                    delete window.csidno;
                }
                const res = await updateOtherPropertyInsurance(this.requestBody);
                if (res.body) {
                    this.$toast.info({ title: res.header.message });
                    this.$router.push({
                        name: "policyInfo-edit-list",
                        query: { modify: this.pt_contractx_id }
                    });
                }
            } else {
                this.$toast.info({ title: "未經客戶同意編輯資料" });
            }
        },
        async doCreate() {
            if(this.confirm_checkbox){
                await this.checkValidate();
                if(window.trn_cd){
                    await insertDataCollectionLog(this.$store.state.userInfo.id, window.csidno, window.trn_cd).then(result => {
                        if(!result.header || !result.header.status === '200') {
                            if(result.header.message) {
                              this.$toast.info({title: result.header.message})
                            } else {
                              this.$toast.info({title: `${resMessage}`})
                            }     
                        }
                    })
                    delete window.trn_cd;
                    delete window.csidno;
                }
                const res = await createOtherPropertyInsurance(this.requestBody);
                if (res.body) {
                    let pt_contractx_id = res.body.pt_contractx_id || "";
                    this.$toast.info({ title: res.header.message });
                    this.$router.push({
                        name: "policyInfo-edit-list",
                        query: { modify: pt_contractx_id }
                    });
                }
            } else {
                this.$toast.info({ title: "未經客戶同意編輯資料" });
            }
        },
        async doDelete() {
            const res = await deleteOtherPeropertyInsurance({
                pt_contractx_id: this.pt_contractx_id
            });
            if (res.body) {
                this.$toast.info({ title: res.header.message });
                this.$router.push({
                    name: "policyInfo"
                });
            }
        }
    },
    computed: {
        pt_contractx_id() {
            return this.$route.query.pt_contractx_id;
        },
        isCreate() {
            return !this.pt_contractx_id;
        },
        isUpdate() {
            return !!this.pt_contractx_id;
        },

        requestBody() {
            return {...this.editData, rdstdt: this.rdstdt, agidno: this.user_id };
        }
    },
    mounted() {
        this.isUpdate && this.getData();
    }
};